module.exports = __webpack_public_path__ + "img/mobile.3ed03600.svg";